import { LanguageCode } from '@model';
import { z } from 'zod';

export const IdJsonSchema = z.string().or(z.number());

export const MultiLanguageJsonSchema = z.record(
  z.nativeEnum(LanguageCode),
  z.string(),
);
